import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostCustomerProductTradeShareList(params) {
  return request(
    `${BASE_URL}/provider/wms/trade/customer/product/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
//  交易录入查询
export async function rqtPostListTradeInputPage(params) {
  return request(
    `${BASE_URL}/provider/wms/trade/input/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtPostCountTradeInputPage(params) {
  return request(
    `${BASE_URL}/provider/wms/trade/input/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 交易保存
export async function rqtPostTradeSave(params) {
  return request(
    `${BASE_URL}/provider/wms/trade/`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 交易流程审核（复核，审核等）
export async function rqtPostTradeAudit(params) {
  return request(
    `${BASE_URL}/provider/wms/trade/audit/`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 交易状态修改
export async function rqtPostTradeUpdate(params) {
  return request(
    `${BASE_URL}/provider/wms/trade/status/update/`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
// 打开交易详情
export async function rqtGetTradeDetail(tradeId,auditStatus) {
  return request(`${BASE_URL}/provider/wms/trade/detail/${tradeId}/${auditStatus}`, METHOD.GET)
}